import React, { useCallback, useEffect, useRef, useState } from 'react'
import styled, { css, ITheme } from '../../theme'
import Scrollbars from '../../components/Scrollbars/Scrollbars'
import { Null } from '../Template/Sidebar/Menu/SidebarContent'
import { is } from '../../components/MediaQuery'
import { useTranslation } from 'react-i18next'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import YouTubePlayer from '../../components/YouTubePlayer/YouTubePlayer'

const Wrapper = styled.div<{ mobile?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: calc(var(--full) - 105px);

  ${props =>
    props.mobile &&
    css`
      height: 100vh;
    `}
`

const LeftContent = styled.div<any>`
  width: 100%;
  padding: 20px 30px;
  padding-right: 0px;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    padding: 15px;
  }
`
export const RightContetnt = styled.div<any>`
  width: 100%;
  max-width: 448px;
  background-color: #ebedef;
  z-index: 1301;
  padding: 18px;
  padding-right: 0px;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    max-width: unset;
    padding: 18px;
    overflow: scroll;
    height: calc(var(--full) - 138px);
    ${props =>
      props.mobile &&
      css`
        height: calc(var(--full) - 50px);
      `}
  }
`

export const HelperWrapper = styled.div<any>`
  margin: 0px -15px -15px;
  max-height: ${props => (props.open ? (props.height || 'calc(100% + 18px)') : '50px')};
  width: 100%;
  overflow: hidden;
  position: absolute;
  z-index: 2000;
  bottom: 0;
  transition: max-height 0.3s ease-in-out;
  ${props =>
    props.mobile &&
    css`
      margin: 0px -15px 0px;
    `}
`

export const HelperTitle = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #d4d4d4;
  width: 100%;
  height: 50px;
  padding: 0px 15px;
  cursor: pointer;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: #000000;
  text-decoration: none solid rgb(0, 0, 0);
  font-weight: bold;
  border-radius: ${(props: any) =>
    props.open ? '8px 8px 0px 0px' : '0px 0px 8px 8px'};
`

function SplitScreen({
  RComp,
  LComp,
  Header,
  tab,
  mobile = false,
}: ISplitScreen) {
  const isDesktop = is.desktop()
  const [helper, setHelper] = React.useState(false)
  const ref = useRef<HTMLDivElement | null>(null)
  const [width, setWidth] = React.useState(412)

  useEffect(() => {
    setHelper(false)
  }, [])

  const toggleHelper = () => {
    setHelper(!helper)
  }

  const { t } = useTranslation()

  const [stopVideo, setStopVideo] = useState(null)

  const onStopVideo = useCallback(stopFunction => {
    setStopVideo(() => stopFunction)
  }, [])

  const handleStopClick = () => {
    if (stopVideo) {
      stopVideo()
    }
  }

  useEffect(() => {
    if (!helper) {
      handleStopClick()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [helper])

  useEffect(() => {
    //set with on resize
    const handleResize = () => {
      if (ref.current) {
        setWidth(ref.current.getBoundingClientRect().width)
      }
    }

    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <Wrapper mobile={mobile}>
      <LeftContent open={helper}>
        <Header />
        <Scrollbars
          disableAutoBlocking={true}
          style={
            tab === 1 && {
              width: 'calc(100% + 30px)',
              marginLeft: '-15px',
            }
          }
          hideTracksWhenNotNeeded={true}
          autoHide={true}
          autoHeightMin={'200px'}
          autoHeightMax={
            isDesktop
              ? 'calc(var(--full) - 180px)'
              : `calc(var(--full) - ${mobile ? 95 : 200}px)`
          }
          autoHideTimeout={300}
          autoHideDuration={200}
          renderTrackHorizontal={Null}
          renderThumbHorizontal={Null}
          autoHeight={true}
        >
          {LComp}
        </Scrollbars>
        {!isDesktop && (
          <HelperWrapper mobile={mobile} open={helper}>
            <HelperTitle open={helper} onClick={toggleHelper}>
              {t('OUT_4832_instruction_mobile_1')}
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {t(
                  helper
                    ? 'OUT_4832_instruction_mobile_3'
                    : 'OUT_4832_instruction_mobile_2',
                )}
                {helper ? (
                  <FiChevronDown
                    style={{
                      fontSize: '20px',
                      marginLeft: '5px',
                    }}
                  />
                ) : (
                  <FiChevronUp
                    style={{
                      fontSize: '20px',
                      marginLeft: '5px',
                    }}
                  />
                )}
              </div>
            </HelperTitle>

            <RightContetnt ref={ref} mobile={mobile}>
              <YouTubePlayer
                width={width - 35}
                height={(width - 35) / 1.7777}
                videoId="rniGtgqHCHU"
                onStop={onStopVideo}
              />
              <RComp />
            </RightContetnt>
          </HelperWrapper>
        )}
      </LeftContent>
      {isDesktop && (
        <RightContetnt>
          <Scrollbars
            hideTracksWhenNotNeeded={true}
            autoHide={true}
            autoHeightMin={'200px'}
            autoHeightMax={'calc(var(--full) - 180px)'}
            autoHideTimeout={300}
            autoHideDuration={200}
            renderTrackHorizontal={Null}
            renderThumbHorizontal={Null}
            autoHeight={true}
          >
            <YouTubePlayer
              width={412}
              height={412 / 1.7777}
              videoId="rniGtgqHCHU"
              onStop={onStopVideo}
            />
            <RComp />
          </Scrollbars>
        </RightContetnt>
      )}
    </Wrapper>
  )
}

export interface ISplitScreen {
  RComp: React.FC
  LComp: React.ReactNode
  Header: React.FC
  mobile?: boolean
  tab: number
}

export default SplitScreen
